import {
    EMPTY_ATTRIBUTES_FILTER,
    EMPTY_CONSTRUCTOR_FILTER,
    EMPTY_CUSTOMER_FILTER,
    EMPTY_CUSTOMER_NUMBER_FILTER,
    EMPTY_HEADER_FILTER,
    EMPTY_MODEL_FILTER,
    EMPTY_ORDER_NUMBER_FILTER,
    EMPTY_TECHNOLOGIST_FILTER
} from "../OrderStatus";
import {matchEmptyOrIncludes} from "../../utils/common/matchEmptyOrIncludes";

export const OrderConstructorTableFilterData = [
    {
        "idFromColumnFilter": "number",
        "id": "number",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_ORDER_NUMBER_FILTER, options)
    },
    {
        "idFromColumnFilter": "customerName",
        "id": "customerName",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_CUSTOMER_FILTER, options)
    },
    {
        "idFromColumnFilter": "header",
        "id": "header", "field": "name",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_HEADER_FILTER, options)
    },
    {
        "idFromColumnFilter": "models",
        "id": "estimate",
        "field": "modules",
        "filterFn": (value, filterValue, _enum, options) => {
            const names = (value || []).map((module) => module?.originalName).filter(Boolean)
            if (filterValue === EMPTY_MODEL_FILTER) {
                return names.length === 0
            }
            const needle = String(filterValue ?? '').toLowerCase()
            return names.some((name) => options?.exact
                ? name.toLowerCase() === needle
                : name === filterValue || name.toLowerCase().includes(needle))
        }
    },
    {
        "idFromColumnFilter": "dateOfReceipt",
        "id": "dateOfReceipt",
        "filterFn": (value, filterValue) => value != null && new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "constructor",
        "id": "constructor", "field": "name",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_CONSTRUCTOR_FILTER, options)
    },
    {
        "idFromColumnFilter": "technologist",
        "id": "technologist", "field": "name",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_TECHNOLOGIST_FILTER, options)
    },
    {
        "idFromColumnFilter": "numberCustomer",
        "id": "numberCustomer",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_CUSTOMER_NUMBER_FILTER, options)
    },
    {
        "idFromColumnFilter": "dateOfConstructorDocumentation",
        "id": "dateOfConstructorDocumentation",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "dateOfPlannedProduction",
        "id": "dateOfPlannedProduction",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "dateOfTechnicalDocumentation",
        "id": "dateOfTechnicalDocumentation",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "attributes",
        "id": "attributes",
        "filterFn": (value, filterValue) => {
            if (filterValue === EMPTY_ATTRIBUTES_FILTER) {
                return !value || value.length === 0
            }
            return value?.some((el) => el.name?.toLowerCase().includes(String(filterValue).toLowerCase()))
        }
    }
]
